var render = function render(_c,_vm){return (_vm.data.staticClass || (typeof _vm.props.value !== 'undefined' && _vm.props.valueClasses[_vm.props.value.toString()]))?_c('tag',{staticClass:"-s",class:_vm.data.staticClass || _vm.props.valueClasses[_vm.props.value.toString()]}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }